import {NgModule, ErrorHandler, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID} from '@angular/core';

import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { VoltioPlatformApp } from './app.component';

import { ThemesPage, VoltioLandingPage, BillSummaryPage, ResidentRegisterPage,
          BillCreatePage, ResidentSummaryPage, LoginPage, SignupPage,LogoutPage,
          ProjectNumberGeneratorPage} from '../pages/index';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import {AngularFireModule} from 'angularfire2';

import {DateFormatPipe } from 'angular2-moment';
import {ThemeService, AuthService} from '../providers/index';

// Must export the config
// TODO: fix environment when this thread is closed: https://github.com/driftyco/ionic-app-scripts/issues/762
export const firebaseConfig = {
  apiKey: "AIzaSyBQvOX7HuMFQiVrpN07tcUHU62VanmhofM",
  authDomain: "linear-reporter-125211.firebaseapp.com",
  databaseURL: "https://linear-reporter-125211.firebaseio.com",
  storageBucket: "linear-reporter-125211.appspot.com",
  messagingSenderId: "265724846895"
};

@NgModule({
  declarations: [
    VoltioPlatformApp,
    VoltioLandingPage,
    BillSummaryPage,
    ResidentRegisterPage,
    BillCreatePage,
    ResidentSummaryPage,
    ThemesPage,
    LoginPage,
    SignupPage,
    LogoutPage,
    ProjectNumberGeneratorPage,
    DateFormatPipe
  ],
  imports: [
    IonicModule.forRoot(VoltioPlatformApp),
    AngularFireModule.initializeApp(firebaseConfig ) //, authConfig, 'my-app-name')
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    VoltioPlatformApp,
    VoltioLandingPage,
    ResidentSummaryPage,
    ResidentRegisterPage,
    BillSummaryPage,
    BillCreatePage,
    ThemesPage,
    LoginPage,
    LogoutPage,
    SignupPage,
    ProjectNumberGeneratorPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    ThemeService,
    AuthService,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    { provide: LOCALE_ID, useValue: 'en-AU' } //TODO: need this working
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts